import { BackendConfigAbTestsInterface } from 'common/data/backend/config/ab-tests.interface';

export function configGetAbTests(): BackendConfigAbTestsInterface {
  return window.propertyfinder && window.propertyfinder.abTests ? window.propertyfinder.abTests : {};
}
